module.exports = __webpack_public_path__ + "static/img/ac66f4f.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/simulate/images/fail.png
// module id = 693
// module chunks = 2